import { c as _c } from "react/compiler-runtime";
import { useBack } from "@website/hooks/back";
import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { addEventToTracking } from "@website/tracking/user";
import { getCarrierByPhoneNumber } from "@website/utils/mobile-carrier-map";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
import { PhoneNumberCardPropertiesType } from "@website/widget/login/components/phone-number-card/phone-number-card.types";
import { AuthRequestOtpService } from "@website/widget/login/services/auth-request-otp";
import { SendOtpService } from "@website/widget/login/services/send-otp";
import { getLoginErrorMessage, isPhoneNumberPartiallyValid, isPhoneNumberValid, toEnglishDigits } from "@website/widget/login/utils";
import { useCompatRouter } from "@website/hooks/compat-router";
import { ChangeEvent, useState } from "react";
export const usePhoneNumberCard = properties => {
  const $ = _c(20);
  const {
    setStep,
    setUserData,
    userData,
    isWelcomeScreen
  } = properties;
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const router = useCompatRouter();
  const {
    goBack
  } = useBack();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = replaceSnappTripBasedOnChannel("\u0648\u0631\u0648\u062F \u0628\u0647 \u0627\u0633\u0646\u067E\u200C\u062A\u0631\u06CC\u067E");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const headerTitle = t0;
  const modalTitle = isWelcomeScreen ? "\u0633\u0631\u06CC\u0639\u200C\u060C \u0647\u0648\u0634\u0645\u0646\u062F\u0627\u0646\u0647 \u0648 \u0645\u0637\u0627\u0628\u0642 \u0633\u0644\u06CC\u0642\u0647 \u062E\u0648\u062F\u062A\u0627\u0646 \u0631\u0632\u0631\u0648 \u06A9\u0646\u06CC\u062F." : "\u0628\u0631\u0627\u06CC \u0627\u062F\u0627\u0645\u0647 \u0644\u0637\u0641\u0627 \u0634\u0645\u0627\u0631\u0647 \u0645\u0648\u0628\u0627\u06CC\u0644 \u062E\u0648\u062F \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F.";
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = event => {
      const {
        value
      } = event.target;
      const normalizedValue = toEnglishDigits(value);
      if (isPhoneNumberPartiallyValid(normalizedValue)) {
        setPhoneNumber(normalizedValue);
      }
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onChangePhoneNumber = t1;
  let t2;
  if ($[2] !== phoneNumber || $[3] !== setStep || $[4] !== setUserData || $[5] !== userData) {
    t2 = async _event => {
      _event.preventDefault();
      if (isPhoneNumberValid(phoneNumber)) {
        setIsLoading(true);
        setError("");
        addEventToTracking(USER_TRACKING_EVENTS.CREDENTIAL_ENTERED, {
          product: "core",
          carrier: getCarrierByPhoneNumber(phoneNumber)
        });
        SendOtpService({
          phoneNumber
        }).then(data => {
          if (data?.availableAuthMethods.includes("password")) {
            setIsLoading(false);
            setStep("password");
            setUserData({
              ...userData,
              phoneNumber
            });
          } else {
            if (data?.availableAuthMethods.includes("password")) {
              setError("\u0646\u0645\u06CC\u062A\u0648\u0627\u0646\u06CC\u062F \u0648\u0627\u0631\u062F \u0634\u0648\u06CC\u062F. \u0644\u0637\u0641\u0627 \u0628\u0627 \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC \u062A\u0645\u0627\u0633 \u0628\u06AF\u06CC\u0631\u06CC\u062F.");
            } else {
              AuthRequestOtpService({
                phoneNumber
              }).then(data_0 => {
                setStep("otp");
                setUserData({
                  ...userData,
                  ...data_0,
                  phoneNumber
                });
              }).catch(error_0 => {
                setError(getLoginErrorMessage(error_0));
              }).finally(() => setIsLoading(false));
            }
          }
        }).catch(error_1 => {
          setError(getLoginErrorMessage(error_1));
        }).finally(() => setIsLoading(false));
      } else {
        setError("\u0634\u0645\u0627\u0631\u0647 \u062A\u0644\u0641\u0646 \u0645\u0639\u062A\u0628\u0631 \u0646\u06CC\u0633\u062A.");
      }
    };
    $[2] = phoneNumber;
    $[3] = setStep;
    $[4] = setUserData;
    $[5] = userData;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const onSubmitPhoneNumber = t2;
  let t3;
  if ($[7] !== router?.pathname) {
    t3 = typeof window !== "undefined" && (router?.pathname.includes("/profile") || window.history.length <= 1 || document.referrer && !document.referrer.includes(window.location.host));
    $[7] = router?.pathname;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const shouldRedirectToHome = t3;
  const backButtonText = shouldRedirectToHome ? "\u0628\u0627\u0632\u06AF\u0634\u062A \u0628\u0647 \u0635\u0641\u062D\u0647 \u0627\u0635\u0644\u06CC" : "\u0628\u0627\u0632\u06AF\u0634\u062A";
  let t4;
  if ($[9] !== goBack || $[10] !== shouldRedirectToHome) {
    t4 = () => {
      if (shouldRedirectToHome) {
        window.location.href = "/";
      } else {
        goBack();
      }
    };
    $[9] = goBack;
    $[10] = shouldRedirectToHome;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const loginBack = t4;
  let t5;
  if ($[12] !== backButtonText || $[13] !== error || $[14] !== isLoading || $[15] !== loginBack || $[16] !== modalTitle || $[17] !== onSubmitPhoneNumber || $[18] !== phoneNumber) {
    t5 = {
      error,
      isLoading,
      phoneNumber,
      onChangePhoneNumber,
      onSubmitPhoneNumber,
      headerTitle,
      modalTitle,
      loginBack,
      backButtonText
    };
    $[12] = backButtonText;
    $[13] = error;
    $[14] = isLoading;
    $[15] = loginBack;
    $[16] = modalTitle;
    $[17] = onSubmitPhoneNumber;
    $[18] = phoneNumber;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
};